import store from '@/store';

export default class SearchDropdownItemCode {
	constructor(
		private readonly id: number,
		private readonly name: string,
		private readonly email: string
	) { }

	public onClick(): void {
		store.mutations.addRightsUser({
			id: this.id,
			name: this.name,
			email: this.email
		});
	}
}
